import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from '@angular/router';
import {AuthLayoutComponent} from './auth-layout.component';
import {FooterModule} from '../shared/components/footer/footer.module';
import {LottieComponent, provideLottieOptions} from 'ngx-lottie';
import player from 'lottie-web';
import {ToastContainerDirective, ToastrModule} from 'ngx-toastr';

export function playerFactory() {
  return import('lottie-web/build/player/lottie_svg');
}

@NgModule({
  declarations: [AuthLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    FooterModule,
    ToastrModule,
    LottieComponent,
    ToastContainerDirective,
    NgOptimizedImage,
  ],
  providers: [provideLottieOptions({player: () => player})],
})
export class AuthLayoutModule {}
